import React, { useMemo } from 'react';
import { CourseType } from '../../../constants/course-type';
import styles from './course-type-badge.module.scss';

type Props = {
  type: CourseType;
  thin?: boolean;
  showIntegratedMastersLabel?: boolean;
};
function GetBadgeStyle(type: CourseType) {
  switch (type) {
    case CourseType.DirectEntry:
      return `direct-entry`;
    case CourseType.DirectEntryWaiver:
    case CourseType.DEW:
      return `direct-entry-waiver`;
    case CourseType.Pathway:
      return `pathway`;
    case CourseType.Others:
      return `others`;
    case CourseType.ALevel:
      return `a-level`;
    case CourseType.ICAS:
      return 'icas';
    default:
      return null;
  }
}
export default function CourseTypeBadge({ type, thin, showIntegratedMastersLabel }: Props) {
  const badgeClassName = useMemo(() => {
    return `course-type-pill ${styles[`course-type`]} ${styles[`${GetBadgeStyle(type)}`]} ${thin ? styles.thin : ``}`;
  }, [type, thin]);

  return (
    <div
      className={badgeClassName}
      aria-label={`entry route: ${
        type === CourseType.Others && showIntegratedMastersLabel
          ? CourseType.IntegratedMastersProgram
          : type
      }`}
    >
      {type === CourseType.Others && showIntegratedMastersLabel
        ? CourseType.IntegratedMastersProgram
        : type}
    </div>
  );
}
